import { RouteComponentProps } from '@reach/router'
import PageComponent from 'components/Dashboard/PageComponent'
import { BooleanParam, useQueryParam } from 'use-query-params'
import { DashboardTitle } from '../DashboardTitleContext'
import PreviewRecoveryCertificate from './PreviewRecoveryCertificate'
import { RecoveryCertificate as RecoveryCertificateItem } from './RecoveryCertificate'
import RecoveryCertificateList from './RecoveryCertificateList'
import { RecoveryCertificateQuery_recoveryCertificates } from './__generated__/RecoveryCertificateQuery'

export const RecoveryCertificates: PageComponent = ({
  orderId,
}: RouteComponentProps<{
  orderId: RecoveryCertificateQuery_recoveryCertificates['orderId']
}>) => {
  return (
    <div className="container">
      <DashboardTitle title="Recovery Certificates" />

      <RecoveryCertificateList orderId={orderId} />
    </div>
  )
}

RecoveryCertificates.displayName = 'Recovery Certificates'
RecoveryCertificates.path = '/recovery-certificates'

export const RecoveryCertificate = ({
  orderId,
}: RouteComponentProps<{
  orderId: RecoveryCertificateQuery_recoveryCertificates['orderId']
}>) => {
  const [previewRecoveryCertificate] = useQueryParam('previewRecoveryCertificate', BooleanParam)

  return (
    <>
      <DashboardTitle title="Recovery Certificate" />
      {previewRecoveryCertificate ? (
        <div style={{ marginTop: '-20px' }}>
          <PreviewRecoveryCertificate orderId={orderId} />
        </div>
      ) : (
        <div className="container">
          <RecoveryCertificateItem orderId={orderId} />
        </div>
      )}
    </>
  )
}

export default RecoveryCertificates

export const completingFors = [
  'MYSELF',
  'SOMEONE_ELSE',
] as RecoveryCertificateQuery_recoveryCertificates['completingFor'][]

export const travelToDestinations = [
  'EU',
  'USA',
  'AUSTRALIA',
  'OTHER',
] as RecoveryCertificateQuery_recoveryCertificates['travelToDestination'][]

export const typeOfCovidTests = [
  'RT_PCR',
  'RAPID_ANTIGEN_LATERAL_FLOW',
  'NAAT_TMA_LAMP',
] as RecoveryCertificateQuery_recoveryCertificates['typeOfCovidTest'][]

export const lastTimeExperiencedSymptoms = [
  'TIME_48_TO_72_HOURS',
  'TIME_OVER_72_HOURS',
] as RecoveryCertificateQuery_recoveryCertificates['lastTimeExperiencedSymptoms'][]

export const recoveryCertificateStatuses = [
  'NEW',
  'REVIEWING_DOCUMENTATION',
  'AWAITING_RESPONSE_FROM_CUSTOMER',
  'DOCUMENTATION_COMPLETE',
  'CANCELLED',
  'FINAL_REVIEW',
  'APPROVED',
] as RecoveryCertificateQuery_recoveryCertificates['status'][]

export const paymentStatuses = [
  'UNPAID',
  'PAID',
  'CANCELLED_DURING_CHECKOUT',
  'PAYMENT_FAILED',
  'REFUNDED',
] as RecoveryCertificateQuery_recoveryCertificates['paymentStatus'][]
